import script from "./PayView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayView.vue?vue&type=script&setup=true&lang=ts"

import "./PayView.vue?vue&type=style&index=0&id=62fd577e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fd577e"]])

export default __exports__